import api from "./api";
import { API_URLS } from "./api-urls";
import { UserServiceErrorCode } from "./error_enums/user_error";

export interface CreateUserByGoogleDto {
    accessToken: string;
}

export interface GoogleUserSession {
    refreshToken?: string;
    accessToken?: string;
    email?: string;
}

export interface UserResponse {
    data?: unknown;
    errorMessage?: UserServiceErrorCode;
    statusCode?: number;
    success: boolean;
}

function asRecord(value: unknown): Record<string, unknown> | null {
    return value != null && typeof value === "object" ? (value as Record<string, unknown>) : null;
}

export function extractGoogleUserSessionFromResponse(response: UserResponse): GoogleUserSession {
    const top = asRecord(response);
    const data = asRecord(top?.data);

    const accessToken = data?.accessToken ?? data?.token ?? top?.accessToken ?? top?.token;
    const refreshToken = data?.refreshToken ?? top?.refreshToken;
    const email = data?.email ?? top?.email;

    return {
        accessToken: typeof accessToken === "string" ? accessToken.trim() : undefined,
        refreshToken: typeof refreshToken === "string" ? refreshToken.trim() : undefined,
        email: typeof email === "string" ? email.trim() : undefined,
    };
}

export async function createUserByGoogle(userData: CreateUserByGoogleDto): Promise<UserResponse> {
    const response = await api.post<UserResponse>(API_URLS.CREATE_USER_BY_GOOGLE, userData);
    return response.data;
}


